import PropTypes from "prop-types"
import React from 'react'

export default function OgImage({image, title}) {
  return (
<>
  {/* Facebook Meta Tags */}
  <meta property="og:url" content={image} />
  <meta property="og:type" content="website" />
  <meta property="og:title" content={title} />
  <meta property="og:description" content />
  <meta property="og:image" content={image} />
  {/* Twitter Meta Tags */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta property="twitter:domain" content="actionis-consulting.com" />
  <meta property="twitter:url" content={image} />
  <meta name="twitter:title" content={title} />
  <meta name="twitter:description" content />
  <meta name="twitter:image" content={image} />
  {/* Meta Tags Generated via https://www.opengraph.xyz */}
</>
  )
}

OgImage.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string
}
